/**
 * Runtime configuration.
 *
 * In production (nginx container) values come from window._env_,
 * which is generated at container startup from environment variables.
 * In development (npm start), API requests use relative /api and setupProxy.js
 * reads REACT_APP_API_BASE_URL as the proxy target.
 */

const env = window._env_ || {};
const DEFAULT_API_BASE_URL = '';
const DEFAULT_GOOGLE_CLIENT_ID = '';

export const API_BASE_URL = env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

export const GOOGLE_CLIENT_ID =
  env.REACT_APP_GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || DEFAULT_GOOGLE_CLIENT_ID;
